module.exports = __webpack_public_path__ + "img/teacher_icon.31c3147e.png";